/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dealflowEnrichmentItemDtoSchema } from "./dealflowEnrichmentItemDtoSchema.ts";
import { z } from "zod/v4";

export const dealflowEnrichmentInfoDtoSchema = z.object({
  get internalBusinessPlan() {
    return z.array(dealflowEnrichmentItemDtoSchema).optional();
  },
  get externalFinancialModel() {
    return z.array(dealflowEnrichmentItemDtoSchema).optional();
  },
});
